// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class CommunicationsBaseService {
  protected _showSurveyNotifications$: BehaviorSubject<boolean | null>;
  get showSurveyNotifications$(): Observable<boolean | null> {
    return this._showSurveyNotifications$.asObservable();
  }

  protected _showUpdatesInspirationOffers$: BehaviorSubject<boolean | null>;
  get showUpdatesInspirationOffers$(): Observable<boolean | null> {
    return this._showUpdatesInspirationOffers$.asObservable();
  }

  constructor() {
    this._showSurveyNotifications$ = new BehaviorSubject<boolean | null>(null);
    this._showUpdatesInspirationOffers$ = new BehaviorSubject<boolean | null>(null);
  }

  abstract loadUserCommunicationPreferences(): void;
  abstract setShowUpdates(value: boolean): void;
  abstract setShowSurveyNotifications(value: boolean): void;
}
